<template>
  <div class="firstRow">
    <div class="content-box">
      <div class="left">
        <span class="title">{{ fullTicketInfo.title }}</span>
      </div>
      <div class="right" @click="stateNotice = true">
        <span>购票须知</span>
        <img src="~@/assets/image/common/common_goTo2.png" alt="" />
      </div>
    </div>
    <div class="visit-box" v-if="fullTicketInfo.travelNotice" @click="travelNoticeClick">
      <span>参观游览须知</span>
      <img src="~@/assets/image/common/common_goTo2.png" alt="" />
    </div>
    <remind
      @fullEvents="fullEvents"
      :currentNotice="fullTicketInfo"
      :stateNotice="stateNotice"
      :price="fullPrice"
    >
    </remind>
    <TravelRemind
      @fullEvents="fullEvents"
      :currentNotice="fullTicketInfo"
      :travelNotice="travelNotice"
      :price="fullPrice"
    >
    </TravelRemind>
  </div>
</template>

<script>
import remind from "@/components/buyTickets/common/remind";
import TravelRemind from "@/components/buyTickets/common/TravelRemind";
export default {
  name: "firstRow",
  props: ["fullTicketInfo", "fullPrice"],
  data() {
    return {
      stateNotice: false,
      travelNotice: false
    };
  },
  methods: {
    travelNoticeClick() {
      this.travelNotice = true
    },
    fullEvents(options) {
      const { type, stateNotice = null } = options;
      if (type === "closeNotice") this.closeNotice(stateNotice);
      if(type === 'closeTravelNotice') this.travelNotice = !this.travelNotice
      if (type === "clickPay") this.clickPay();
    },
    closeNotice() {
      this.stateNotice = !this.stateNotice;
    },
    clickPay() {
      this.stateNotice = false;
      this.$emit("clickPay");
    }
  },
  components: {
    remind,
    TravelRemind
  }
};
</script>

<style scoped lang="less">
.firstRow {
  background: #ffffff;
  position: relative;
  padding: 0 0.266667rem;
  margin-top: 0.266667rem;
  .content-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 1.52rem - 0.133333rem;

    .left {
      font-weight: bold;
      display: flex;
      align-items: center;
      .title {
        font-size: 0.48rem;
        color: #222328;
        max-width: 10em;
      }
    }
    .right {
      font-size: 0.32rem;
      color: #333333;
      line-height: 0.44rem;
      display: flex;
      align-items: center;
      span {
        white-space: nowrap;
      }
      img {
        height: 0.32rem;
        margin-left: 0.066667rem;
      }
    }
  }
  .visit-box {
    border-bottom: 1px dashed #3b6d9c;
    font-size: 0.32rem;
    display: flex;
    justify-content: flex-end;
    padding-bottom: 0.2rem;
    img {
      height: 0.32rem;
      margin-left: 0.066667rem;
    }
  }
}
</style>
